export const DateOfBirthContent = {
  content1: 'Your entry is invalid.',
  content2: 'The date of death cannot be before the date of birth.',
  dobLabel: 'Date of birth (mm/dd/yyyy)',
};
